import { createContext, useContext } from 'react';

export type ArticleCategory = {
    id: number;
    label: string;
    validatorTypeId: number;
};

const articleCategories: Array<ArticleCategory> = [];

const DossierArticleContext = createContext({
    articleCategories,
});

export const useDossierArticleContext = () => useContext(DossierArticleContext);

export default DossierArticleContext;
